<script setup lang="ts">
import {NotificationTemplate as INotificationTemplate} from "@/notification-template/interfaces";
import NotificationPreview from "@/core/components/notification-preview/NotificationPreview.vue";
import RCSNotificationTemplate from "@/notification-template/components/RCSNotificationTemplate.vue";
import NotificationPreviewHeading from "@/core/components/notification-preview/NotificationPreviewHeading.vue";
import NotificationTemplateService from "@/notification-template/services/NotificationTemplateService";

const {showHeading = true} = defineProps<{
    template: INotificationTemplate;
    when: string;
    showHeading?: boolean;
}>();
</script>

<template>
  <NotificationPreview
    v-if="template.type === 'sms'"
    :content="template.parsed_content ?? template.content"
    type="sms"
    :count="0"
    :when="when"
    :heading="showHeading"
  />
  <div v-else-if="NotificationTemplateService.isRcsType(template)" class="flex flex-col items-center gap-2">
    <NotificationPreviewHeading v-if="showHeading" type="sms" :when="when" />
    <RCSNotificationTemplate :template="template" />
  </div>
</template>

<style scoped>

</style>
